define.alias("shared/components/shared/ember-drop-multi-select-item", "settings/components/shared/ember-drop-multi-select-item");